import {CssBaseline, StyledEngineProvider, ThemeProvider} from '@mui/material';
import {LicenseInfo} from '@mui/x-data-grid-pro';
import React, {Suspense} from 'react';
import {Provider} from 'react-redux';
import App from './App';
import {ErrorBoundary} from './app/common/components/ErrorBoundary/ErrorBoundary';
import {Loader} from './app/common/components/Loader/Loader';
import {store} from './app/store';
import {configureI18N} from './app/utils/i18n';
import themeGlobal from './AppGlobalTheme';
import * as serviceWorker from './serviceWorker';
import version from './version';
import {createRoot} from 'react-dom/client';

console.info(`Starting Websak Admin+. Running version %c${version}%c on %c${navigator.userAgent}`, 'color: orange', '', 'color: darkgreen');

LicenseInfo.setLicenseKey('d6b158b57c2a6bb550e8555526bb3bbdT1JERVI6MzAyMzYsRVhQSVJZPTE2NjQ3MTY4MTcwMDAsS0VZVkVSU0lPTj0x');

configureI18N();
const container = document.getElementById('root');
const root = createRoot(container!);
//TODO Enable React strict mode when we update material ui to version 5 (currently in alpha 27) <React.StrictMode></React.StrictMode>,
root.render(
  <React.Fragment>
    
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themeGlobal}>  
        <Provider store={store}>  
        <CssBaseline />
          <Suspense fallback={<Loader />}>
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
          </Suspense>
        </Provider>
      </ThemeProvider>
    </StyledEngineProvider>
  </React.Fragment>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
